module.exports = __webpack_public_path__ + "static/media/cyberpunk.261b0015.jpg";